$(document).ready(function() {
  // contact page (field validation)
  $("input,input[type='email'], textarea").on("keyup", function(){
    var email = $("input[type='email']").val();
    if($(this).val() != "" && $("textarea").val() != "" && IsEmail(email) == true){
        $("button[type='submit']").removeAttr("disabled");
    } else {
        $("button[type='submit']").attr("disabled", "disabled");
    }
    let count = 0;
    $('.form-fields-list .in_field').each(function(){
      let input_count = $('.form-fields-list .in_field').length - 1;
      if($(this).val() != ''){
        count = count + 1;
      }
      if(count == input_count){
        $('.err_msg').addClass('field_active');
      }else{
        $('.err_msg').removeClass('field_active');
      }
    });
  });
   function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
      return false;
    }else{
      return true;
    }
  } 
});